import React, { Component } from 'react';
import SearchRecord from './SearchRecord';
import ShowEntries from './ShowEntries';
import TableContent from './TableContent';
import Pagination from './Pagination';
import Wrp from '../../../hoc/Wrp/Wrp';
import Buttons from '../Buttons';
class TableRecord extends Component {
    
   
    render () {
        // console.log(this.props.tableRecords);
        const {actionBtn} =this.props;
        let wrp = {
            element:(this.props.widthoutPagination)?Wrp :'div'
        }
   
        return (
            
                     
                        <wrp.element className="table_Box dataTables_wrapper">
                            {this.props.isHeader===true && 
                            <div className="table_Header">
                                {(this.props.tableRecords.pagination.perPage)?
                                    <div className="d-flex align-items-center justify-content-between">
                                         {(actionBtn.length>0)?
                                            <Buttons buttonList = {actionBtn}/>
                                        :""}
                                        <ShowEntries {...this.props.tableRecords.pagination} recordsChangeHandler={this.props.recordsChangeHandler}/>
                                        <SearchRecord {...this.props.tableRecords.pagination}  recordsChangeHandler={this.props.recordsChangeHandler}/>
                                    </div>
                                :''}
                            </div>
                            }
                            <div className="table_Body p-0 table-responsive nowrap">
                                <wrp.element className=" ">
                                    <wrp.element className=" ">
                                        <TableContent 
                                            tHeadClassName={this.props.tHeadClassName}
                                            {...this.props.tableRecords.pagination} 
                                            className={this.props.className}
                                            tableRecords={this.props.tableRecords}
                                            recordsChangeHandler={this.props.recordsChangeHandler}
                                        />
                                    </wrp.element>
                                </wrp.element> 
                            </div>  
                            {this.props.widthoutPagination===false && 
                            <div className="table_Footer">
                                {(this.props.tableRecords.pagination.perPage)? 
                                    <Pagination 
                                        {...this.props.tableRecords.pagination}
                                         recordsChangeHandler={this.props.recordsChangeHandler}
                                    />
                                :''}   
                            </div>
                            }
                        </wrp.element>
                             
                                
                    

            
        )
    }
}

TableRecord.defaultProps = {
    actionBtn:[],
    widthoutPagination:false,
    isHeader:true
}
export default TableRecord;